import { NON_DIGIT_REGEX } from './regexp'

export const formatPostalCode = (value: string) => {
  const digits = value.replace(NON_DIGIT_REGEX, '')
  if (digits.length <= 5) return digits
  return `${digits.slice(0, 5)}-${digits.slice(5, 9)}`
}
